/** Элемент с onLoad или procedure в метаданных */
export function elementHasServerLoadScript(elementConfig: { element?: unknown } | null | undefined): boolean {
  const el = elementConfig?.element as Record<string, any> | undefined
  if (!el) return false

  const readText = (node: unknown): string => {
    if (node == null) return ''
    if (typeof node === 'string') return node.trim()
    if (typeof node === 'object' && node !== null && '_text' in (node as object)) {
      return String((node as { _text?: unknown })._text ?? '').trim()
    }
    return ''
  }

  if (readText(el.onLoad)) return true

  const proc = el.procedure
  if (proc && typeof proc === 'object') {
    if (readText((proc as Record<string, unknown>).code)) return true
  }
  return false
}
